import React, { useState } from "react";

import { useSelector } from "react-redux";

import ContactInfoNudge from "employee/ContactInfoNudge";

import { CodeRequestCard, EnterCodeCard } from "./HubAuthCard";
import HubPageWrapper from "./HubPageWrapper";
import { StateType } from "./types";
import { CompanyHubAuthCard } from "./CompanyHubAuthCard";
import HubComponent from "./HubComponent";

function HubPage({
    title = "",
    subtitle = "To begin your survey, please log in.",
    field1,
    field2,
    companySlug,
    buttonRenamer = {},
    preAuthenticated = false,
    rememberMeEnabled = true,
}: {
    title?: string;
    subtitle?: string;
    field1?: string;
    field2?: string;
    companySlug?: string;
    buttonRenamer?: object;
    preAuthenticated: boolean;
    rememberMeEnabled?: boolean;
}) {
    const [authenticated, setAuthenticated] = useState(preAuthenticated);

    const [displayLogin, setDisplayLogin] = useState(!preAuthenticated);
    const [displayCodeCheck, setDisplayCodeCheck] = useState(false);

    const [contactInfo, setContactInfo] = useState("");
    const companyNameState = useSelector<StateType, string>((state) => state.company?.name ?? "");

    const surveyTitle = title || `Welcome to ${companyNameState} Surveys!`;

    return (
        <HubPageWrapper hideProfileButton={!authenticated}>
            {!authenticated && companySlug && (
                // Company auth page
                <CompanyHubAuthCard
                    title={surveyTitle}
                    subtitle={subtitle}
                    field1={field1}
                    field2={field2}
                    companySlug={companySlug}
                    buttonRenamer={buttonRenamer}
                    setAuthenticated={setAuthenticated}
                    rememberMeEnabled={rememberMeEnabled}
                />
            )}
            {!authenticated && displayLogin && !companySlug && (
                // Request code page
                <CodeRequestCard
                    setVisible={setDisplayLogin}
                    setContactInfo={setContactInfo}
                    showDisplayCode={setDisplayCodeCheck}
                />
            )}
            {!authenticated && !displayLogin && displayCodeCheck && !companySlug && (
                // enter code page
                <EnterCodeCard
                    contactInfo={contactInfo}
                    setVisible={setDisplayCodeCheck}
                    setLoginVisible={setDisplayLogin}
                    setAuthenticated={setAuthenticated}
                />
            )}
            {authenticated && (
                // Post-authentication page - for now just a placeholder
                <>
                    <ContactInfoNudge />
                    <HubComponent />
                </>
            )}
        </HubPageWrapper>
    );
}

export default HubPage;
